// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RhpT","placeholdersHeader":"styles_placeholdersHeader__LVb9u","editorStyle":"styles_editorStyle__2_9x5","placeholdersBox":"styles_placeholdersBox__2uDDy"};